function readEnvFlag(value: string | undefined): boolean {
  return value === "true";
}

function readSampleRate(value: string | undefined, fallback: number): number {
  const parsed = value === undefined ? NaN : Number.parseFloat(value);
  if (!Number.isFinite(parsed)) return fallback;
  return Math.min(1, Math.max(0, parsed));
}

export type AnalyticsConfig = {
  enabled: boolean;
  apiKey: string | null;
  apiHost: string | null;
  sessionReplay: {
    enabled: boolean;
    sampleRate: number;
  };
};

export function readAnalyticsConfig(): AnalyticsConfig {
  const env = import.meta.env;
  const apiKey = env.VITE_POSTHOG_KEY?.trim() || null;
  const apiHost = env.VITE_POSTHOG_HOST?.trim() || null;
  const enabled =
    readEnvFlag(env.VITE_POSTHOG_ENABLED) &&
    Boolean(apiKey) &&
    Boolean(apiHost);

  return {
    enabled,
    apiKey,
    apiHost,
    sessionReplay: {
      enabled: enabled && readEnvFlag(env.VITE_POSTHOG_SESSION_REPLAY_ENABLED),
      sampleRate: readSampleRate(
        env.VITE_POSTHOG_SESSION_REPLAY_SAMPLE_RATE,
        0.25
      ),
    },
  };
}
